import { useCallback } from 'react';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { addZeroToStart } from '@interlayer/js/app/utils/methods.util';
import { getUtmCookie } from '@interlayer/js/components/system/App/buzz/hooks/useSetUTMCookie';

export const useGetUtmField = () => {
    const { config: { customFieldNumberUtm } } = useRegistrationSelector();

    return useCallback(() => {
        const utmValue: Record<string, string> = {};

        const customFieldValueUtm = getUtmCookie();

        if (customFieldNumberUtm && customFieldValueUtm) {
            utmValue[`custom${addZeroToStart(customFieldNumberUtm)}`] = customFieldValueUtm;
        }

        return utmValue;
    }, [customFieldNumberUtm]);
};
